
import VariantSelect from './VariantSelect'
import Product from '../../graphql/queries/Product'

export default {
  components: {
    VariantSelect
  },
  props: {
    productId: {
      type: [String, Number],
      default: null
    },
    formType: {
      type: String,
      default: 'form'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        this.$fetch()
      }
    },
    visible(newValue) {
      this.open = newValue
    }
  },
  async fetch() {
    if (!this.open) {
      return
    }

    try {
      const { data } = await this.$graphql.query({
        clientId: 'eshop',
        query: Product,
        variables: { where:  { id: this.productId } }
      })

      this.product = data
    } catch (e) {
      this.product = null
    }
  },
  data() {
    return {
      open: this.visible,
      product: null,
      activeVariant: null
    }
  },
  computed: {
    inputAttrs() {
      return {
        size: 'medium',
        width: 'lg',
        controlsPosition: 'right',
      }
    },
    buttonAttrs() {
      return {
        type: 'success',
        icon: 'plus-circle',
        message: true,
        size: 'medium'
      }
    },
    detailsLink() {
      const path = `${this.$cart.continuePath}/${this.product.slug}`
      return this.$pagePath(path)
    }
  },
  methods: {
    onSetVariant(variant) {
      this.activeVariant = variant

      if (this.$refs.form) {
        this.$refs.form.reset()
      }

      this.$emit('set-variant', variant)
    }
  }
}
